import { render, staticRenderFns } from "./IntermediateDegreeView.vue?vue&type=template&id=c2a3ccf6"
import script from "./IntermediateDegreeView.vue?vue&type=script&lang=js"
export * from "./IntermediateDegreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports